import styled from 'styled-components';
import { CardInput } from '../CardInputs/CardsStyledComponents';
import { colors } from '../../styles/Colors';

export const ModalContainer = styled.div`
  min-width: 660px;
  max-height: calc(90vh - 5vh);
  position: fixed;
  background-color: white;
  z-index: 99;
  top: 5vh;
  left: calc(50% - 330px);
  padding: 25px;
  border-radius: 16px;
  overflow-y:   auto;

  @media (max-width: 850px) {
    top: 0;
    left: 0;
    width: 100%;
    min-width: 100%;
    max-height: none;
    height: calc(100% - 48px);
    padding: 16px;
    margin-top: 48px;
    border-radius: 16px 16px 0 0;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DetailTextWrapper = styled.div`
  margin: 8px 0;
  line-height: 20px;

  @media (max-width: 650px) {
    margin: 16px 0;
  }
`;

export const DebtDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;



export const QuotaData = styled.div`
  width: 100%;
  gap: 15px;
  display: flex;
  align-items: baseline;
  padding: 10px 5px 0px 0px;
  span:first-child {
    width: 90%;
  }
  @media (max-width: 650px) {
    width: 100%;
    padding: 5px;
  }

  @media (max-width: 450px) {
    gap: 0px;
  }
`;

export const TableListContainer = styled.div`
  max-height:50vh; 
  width: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.red7} #f1f1f1;
  border: none!important;
`;

export const CardPaymentPlanHeader = styled(CardInput)`
  flex-direction: column;
  width: 100%;
  padding: 20px;
  background-color: ${(props) => props.theme.colors.gray12};
`;
export const TableContainer = styled.div`
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
  border-radius: 16px 16px 0 0; 
  border: none!important;
  overflow: hidden; 
`;

export const TablePaymentPlan = styled.table`
  width: 100%; /* Asegura que la tabla ocupe todo el ancho disponible */
  border-spacing: 0;
  border-collapse: collapse;
  height: 100%;
  border: none!important;
`;

interface RowProps {
  isGray?: boolean;
}
export const TableRow = styled.tr<RowProps>`
  background-color: ${(props) => (props.isGray ? colors.gray12 : colors.white)};
`;

interface TableCellProps {
  size?: 'short' | 'medium' | 'long';
  color?: string;
}
export const TableCell = styled.td<TableCellProps>`
  padding: 10px 15px;
  border: none!important;
  color : ${(props) => props.color ?? colors.gray6};
  width: ${(props) =>
    props.size === 'short'
      ? '20%'
      : props.size === 'medium'
        ? '30%'
        : '50%'}; 

    @media (max-width: 650px) {
      width: ${(props) =>
    props.size === 'short'
      ? '30%'
      : props.size === 'medium'
        ? '35%'
        : '35%'};
      padding: 4px 6px;

    @media (max-width: 400px) {
      span {
        font-size: 12px;
      }
    }
  }
`;

export const TableHeader = styled(TableCell)`
  background-color: ${colors.red12};
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const ContainerButton = styled.div`
  width: 135px;
  justify-self: end;

  @media (max-width: 650px) {
    display: none;
  }
`;

export const ColumDataModalPlan = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px; 
  @media (max-width: 650px) {
    gap: 10px;
    flex-direction: row;
    display: flex;
    justify-content: space-between;

  }
`;

export const CardDataHeader = styled.div`
 display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 0;

  @media (max-width: 650px) {
    gap: 10px;
    flex-direction: column;
    display: flex;
    
  }
`;

export const TableCellWrapper = styled.div`
  display: flex;
  gap: 6px;
`;

export const PartialPayDetailInformation = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`;